// extracted by mini-css-extract-plugin
export default {"searchInfoContainer":"_2CFAHrvb3xGod7B8mDCmOL"};